import { v4 as uuidv4 } from 'uuid'
import { t } from 'ttag'

export const getColumns = () => [
  { header: t`title`, accessorKey: 'title' },
  { header: t`description` },
  { header: t`size`, accessorKey: 'size' },
  { header: t`last changed`, accessorKey: 'changed' },
  { header: '', id: uuidv4() },
]
